<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vi"></a><a id="page_vii"><span class="small">CONTENTS</span></a></p><a id="page_vii">
</a><p class="TocSb1" id="ack"><a id="page_vii"></a><a href="#/xhtml/acknowledgements#ack">Acknowledgments</a></p>
<p class="Toc1a" id="int"><a href="#/xhtml/introduction#int">Introduction: The Eclipse of Heaven</a></p>
<p class="Toc" id="ch-001"><span href="#/xhtml/chapter001#ch001" title="Link target outside of Sample">1.<span class="space1">In the End, God</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter001#ch001" title="Link target outside of Sample">Retrieving a Theological Eschatology</span></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space1">The Visibility of the Invisible God</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">Reforming the Beatific Hope</span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">Heavenly-Mindedness</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">Retrieving the Ascetical Way of Life with God</span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Self-Denial</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">Reforming the Practices of Renunciation</span></p>
<p class="Toc2a" id="epi"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="Toc2" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliographic Essay</span></p>
<p class="Toc2" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index of Authors</span></p>
<p class="Toc2" id="idx-002"><span href="#/xhtml/index002#idx002" title="Link target outside of Sample">Subject Index</span></p>
<p class="Toc2" id="idx-003"><span href="#/xhtml/index003#idx003" title="Link target outside of Sample">Scripture Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?786a3aa2